export default __webpack_public_path__ + "static/media/no-data.b551e9ac.svg";